import { refs, domReady, dispatchEvent } from '../modules/utils.js';

class NavMenu extends HTMLElement {
  static get observedAttributes() {
    return ['data-display'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-display') {
      document.documentElement.toggleAttribute('data-unscrollable', newValue === '');
      dispatchEvent('navmenu:display', { value: newValue === '' });
    }
  }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
  }

  disconnectedCallback() {
    document.removeEventListener('navmenutoggle:toggle', this.toggleListener);
  }

  #listeners() {
    this.toggleListener = this.toggleListener.bind(this);
    document.addEventListener('navmenutoggle:toggle', this.toggleListener);
  }

  toggleListener() {
    this.toggleAttribute('data-display', !this.hasAttribute('data-display'));
  }
}

customElements.define('nav-menu', NavMenu);
